import { connect } from 'react-redux';
import SingleGroup from './SingleGroup';
import { getViewedProductGroup } from '../../../../../../store/associations/selectors';
import { getModals } from '../../../../../../store/modals/selectors';
import { deleteAssociation } from '../../../../../../store/associations/actions';
import { setOpenModal } from '../../../../../../store/modals/actions';

const mapStateToProps = (state) => ({
  viewedProductGroup: getViewedProductGroup(state),
  modals: getModals(state),
});

const mapDispatchToProps = (dispatch) => ({
  deleteAssociation: (associationIRI) => dispatch(deleteAssociation(associationIRI)),
  setOpenModal: (modal, value) => dispatch(setOpenModal(modal, value)),

});

export default connect(mapStateToProps, mapDispatchToProps)(SingleGroup);
